/*
 * Oppie PDP service-FAQ, onderwerp-tabs.
 * Progressive enhancement: zonder JS blijven alle vragen zichtbaar.
 * Met JS verschijnen de chip-tabs en filtert een klik de zichtbare vragen.
 * Crawler-/no-JS-veilig: de fallback toont gewoon alle FAQ-items.
 */
(function () {
  function init(root) {
    if (root.dataset.faqTabsInit) return;

    var tabs = Array.prototype.slice.call(root.querySelectorAll('.oppie-faqtab'));
    var items = Array.prototype.slice.call(root.querySelectorAll('.oppie-qa__item'));
    if (tabs.length < 2 || !items.length) return;

    root.dataset.faqTabsInit = '1';
    root.classList.add('is-enhanced');

    // Optioneel: per tab eerst N vragen, de rest achter een 'Toon alle'-knop.
    var initialVisible = parseInt(root.dataset.initialVisible || '0', 10) || 0;
    var moreBtn = root.querySelector('[data-faq-more]');
    var expanded = {};
    var currentTopic = null;

    function activate(topic) {
      currentTopic = topic;
      tabs.forEach(function (tab) {
        var on = tab.dataset.topic === topic;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.setAttribute('tabindex', on ? '0' : '-1');
      });

      var total = items.filter(function (item) {
        return item.dataset.topic === topic;
      }).length;
      var canCollapse = initialVisible > 0 && total > initialVisible;
      var limit = canCollapse && !expanded[topic] ? initialVisible : Infinity;

      var lastShown = null;
      var shownCount = 0;
      items.forEach(function (item) {
        var show = item.dataset.topic === topic && shownCount < limit;
        if (show) shownCount += 1;
        item.hidden = !show;
        item.classList.remove('is-last-visible');
        if (show) {
          lastShown = item;
        } else {
          item.removeAttribute('open');
        }
      });

      if (lastShown) lastShown.classList.add('is-last-visible');

      if (moreBtn) {
        moreBtn.hidden = !canCollapse;
        moreBtn.setAttribute('aria-expanded', expanded[topic] ? 'true' : 'false');
        moreBtn.textContent = expanded[topic]
          ? moreBtn.dataset.labelLess || ''
          : (moreBtn.dataset.label || '').replace('[n]', total);
      }
    }

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        var wasExpanded = expanded[currentTopic];
        expanded[currentTopic] = !wasExpanded;
        activate(currentTopic);
        // Bij inklappen terug naar de lijst, anders sta je onder een lege plek.
        if (wasExpanded) root.scrollIntoView({ block: 'start', behavior: 'smooth' });
      });
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        activate(tab.dataset.topic);
      });
      // Pijltjes-navigatie tussen tabs (toetsenbord-toegankelijk).
      tab.addEventListener('keydown', function (e) {
        var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!dir) return;
        e.preventDefault();
        var next = tabs[(i + dir + tabs.length) % tabs.length];
        activate(next.dataset.topic);
        next.focus();
      });
    });

    activate(tabs[0].dataset.topic);
  }

  function boot() {
    document.querySelectorAll('.oppie-faq-topics').forEach(init);
  }

  if (document.readyState !== 'loading') {
    boot();
  } else {
    document.addEventListener('DOMContentLoaded', boot);
  }
  // Theme-editor: opnieuw initialiseren bij section-reload.
  document.addEventListener('shopify:section:load', boot);
})();
